import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "row justify-content-center gx-3"
};
var _hoisted_2 = {
  "class": "col-md-5"
};
var _hoisted_3 = {
  id: "search-product",
  "class": "text-start"
};
var _hoisted_4 = ["onMousedown"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  "class": "col-md-3"
};
var _hoisted_7 = {
  "class": "d-grid mt-md-0 mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.term = $event;
    }),
    onBlur: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.showSuggestions = false;
    }),
    onFocus: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.showSuggestions = true;
    }),
    onKeypress: _cache[3] || (_cache[3] = function () {
      return _ctx.searchFromKeyPress && _ctx.searchFromKeyPress.apply(_ctx, arguments);
    }),
    id: "demoIndexSearchQuery",
    type: "search",
    "class": "form-control fc-y-padding form-control-search",
    placeholder: "I want to sell..."
  }, null, 544), [[_vModelText, _ctx.term]]), Object.keys(_ctx.suggestions).length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["dropdown-menu-autocomplete", {
      'd-none': !_ctx.showSuggestions
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, function (suggestion) {
    return _openBlock(), _createElementBlock("a", {
      onMousedown: _withModifiers(function ($event) {
        return $options.search($event, suggestion.text);
      }, ["prevent"]),
      "class": "dropdown-item",
      href: "#"
    }, [_createElementVNode("span", {
      innerHTML: _ctx.suggestedQueryHighlighted(suggestion.text)
    }, null, 8, _hoisted_5)], 40, _hoisted_4);
  }), 256))], 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    onClick: _cache[4] || (_cache[4] = _withModifiers(function () {
      return $options.search && $options.search.apply($options, arguments);
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-primary"
  }, "Search")])])]);
}